import Big from 'big.js';
import { getCurrencySymbol } from '../intl/getCurrencySymbol';

export const isDecimal = price => price % 1 !== 0;


export const isIncomplete = number => number.charAt(number.length - 1) === '.' || number.charAt(number.length - 2) === '.';

export const formatPrice = price => (
    isDecimal(price) ? parseFloat(price.toFixed(2)) : parseInt(price, 10)
);


export const stripCurrencySymbol = (intl, number, currency) => {
    const currencySymbol = getCurrencySymbol(intl, currency);
    const symbol = currencySymbol.prefix ? currencySymbol.prefix : currencySymbol.suffix;
    return number.replace(symbol, '').trim();
};

export const getFormattedAmountWithCurrency = (intl, number, currency, forceDecimal = false) => {
    const formatConfig = {};
    if (currency) { formatConfig.currency = currency; }
    formatConfig.format = isDecimal(number) || forceDecimal ? 'currency' : 'currencyInteger';
    return intl.formatNumber(number, formatConfig);
};


export const fixDecimalFormat = (value) => {
    if (!value) return '';
    return isDecimal(value) ? new Big(value).toFixed(2) : new Big(value).toFixed(0);
};


export const formatAmountToString = amount => (
    isDecimal(amount) ? amount.toFixed(2) : amount.toString()
);


export const stripValue = (value, decimalChar = '', groupChar = '') => {
    const strippedValue = value.toString()
        .replace(new RegExp(`[${groupChar}]`, 'g'), '')
        .replace(new RegExp(`[${decimalChar}]`, 'g'), '.')
        .replace(/(-(?![0-9.])|[^0-9-.])/g, '');
    return strippedValue.match(/^\d*(?:\.\d{0,2})?/)[0];
};


const getInternationalParts = (intl, currency) => {
    let decimalChar = '';
    let groupChar = '';
    new Intl.NumberFormat(intl.locale, { style: 'currency', currency })
        .formatToParts('1000.50').forEach(({ type, value }) => {
            if (type === 'decimal') { decimalChar = value; }
            if (type === 'group') { groupChar = value; }
        });
    return { decimalChar, groupChar };
};


export const normalizeInternationalCurrency = (intl, currency) => (
    (value) => {
        const intlParts = getInternationalParts(intl, currency);
        return stripValue(value, intlParts.decimalChar, intlParts.groupChar);
    }
);
